import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaCog, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import '../../../assets/css/admin/adminPageLayout/profiledropdown.css';

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({
    name: 'Admin User',
    email: 'admin@journeyjunction.com',
    role: 'Administrator',
    profileImage: null
  });
  
  useEffect(() => {
    const loadAdminData = () => {
      const email = localStorage.getItem("adminEmail");
      const name = localStorage.getItem("adminName");
      const role = localStorage.getItem("adminRole");
      const profileImage = localStorage.getItem("adminProfileImage");
      
      setAdminData({
        name: name || (email ? email.split('@')[0] : 'Admin User'),
        email: email || 'admin@journeyjunction.com',
        role: role || 'Administrator',
        profileImage: profileImage || null
      });
    };


    loadAdminData();


    const handleStorageChange = (e) => {
      if (e.key === 'adminEmail' || e.key === 'adminName' || e.key === 'adminRole' || e.key === 'adminProfileImage') {
        loadAdminData();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("adminPassword");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminRole");
    localStorage.removeItem("adminProfileImage");
    localStorage.removeItem("authToken");

    
    navigate('/admin-login');
  };

  const handleProfileClick = () => {
    navigate('/admin/profile');
  };

  const handleSettingsClick = () => {
    navigate('/admin/settings/general');
  };

  const getInitials = () => {
    if (adminData.name && adminData.name !== 'Admin User') {
      return adminData.name.charAt(0).toUpperCase();
    }
    if (adminData.email && adminData.email !== 'admin@journeyjunction.com') {
      return adminData.email.charAt(0).toUpperCase();
    }
    return 'A';
  };

  return (
    <Dropdown align="end" className="jj-profile-dropdown">
      <Dropdown.Toggle as="button" className="jj-profile-toggle">
        <div className="jj-profile-avatar">
          {adminData.profileImage ? (
            <img 
              src={adminData.profileImage} 
              alt={adminData.name} 
              className="jj-profile-img" 
            />
          ) : (
            <div className="jj-profile-initials">
              {getInitials()}
            </div>
          )}
        </div>
        <div className="jj-profile-info">
          <span className="jj-profile-name">{adminData.name}</span>
          <span className="jj-profile-role">{adminData.role}</span>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="jj-profile-menu">
        <div className="jj-profile-menu-header">
          <div className="jj-profile-menu-avatar">
            {adminData.profileImage ? (
              <img src={adminData.profileImage} alt={adminData.name} />
            ) : (
              <div className="jj-profile-menu-initials">
                {getInitials()}
              </div>
            )}
          </div>
          <div className="jj-profile-menu-info">
            <h6>{adminData.name}</h6>
            <p>{adminData.email}</p>
            <span className="jj-profile-menu-badge">
              {adminData.role}
            </span>
          </div>
        </div>

        <Dropdown.Divider className="jj-profile-divider" />

        <Dropdown.Item
          as="button"
          className="jj-profile-menu-item"
          onClick={handleProfileClick}
        >
          <FaUser className="jj-profile-menu-icon" />
          <span>My Profile</span>
        </Dropdown.Item>

        <Dropdown.Item
          as="button"
          className="jj-profile-menu-item"
          onClick={handleSettingsClick}
        >
          <FaCog className="jj-profile-menu-icon" />
          <span>Settings</span>
        </Dropdown.Item>

        <Dropdown.Divider className="jj-profile-divider" />

        <Dropdown.Item
          as="button"
          className="jj-profile-menu-item jj-profile-logout"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="jj-profile-menu-icon" />
          <span>Logout</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;